import { Injectable } from '@angular/core';
import { BessMetadata } from '@twaice-fe/shared/models';


@Injectable()
export class SystemMetadataService {
  getStorageLocation(bessMetadata: BessMetadata | null | undefined): string {
    if (!bessMetadata) return '';

    const {locationCountry, locationCity} = bessMetadata;

    if (locationCountry && locationCity) {
      return `${locationCity}, ${locationCountry}`;
    } else {
      return locationCity || locationCountry || '';
    }
  }
}
